import '../../App.css';
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { SetStateAction } from 'react';
import { setTextRange } from 'typescript';

export default function ManageSideBar({}) {
   
    const location = useLocation();
    const navigate = useNavigate();
    
    if (!location.state) {
        navigate ("/");
    } 
        
        let contact_guid=location?.state?.contact_guid;
        let handicap_id=location?.state?.handicap_id;
        let dealId=location?.state?.dealId;
    

        useEffect(() => {

            if (!location.state && location.pathname !=="/membership/login" &&  location.pathname !=="/membership/verify" ) {
                navigate ("/");
            } 
    
         }, []);

    
    return (
        <div className='col-4 col-sm-4 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mt-5 pt-3'>
        <div className='sidebar_image'>
            <div className='nav_frame'>
           
            <h2 className='text-start fs-3 fw-light'>Manage <br/>Membership</h2>
            {
            location.pathname !=="/membership/login" &&  location.pathname !=="/membership/verify" &&  location.pathname !=="/membership/dashboard" ? 
                
            <div className="step_container mx-auto">
            <div className="col-5 col-sm-5 pt-2 mt-5">
                <ul className="list-group vertical-steps list-group-flush">
                
                    <li className="list-group-item" key="2">
                    <Link to="/membership/manage/payment" state={{"contact_guid":contact_guid, "handicap_id": handicap_id, "dealId": dealId}}>Update Payment and Billing Info</Link>
                    </li>
                    <li className="list-group-item" key="3">
                    <Link to="/membership/manage/personal" state={{"contact_guid":contact_guid, "handicap_id": handicap_id, "dealId": dealId}}>Update Personal Info</Link>
                    </li>
                    
                    </ul>
                </div>
            </div> :
            ""}
            </div>
        </div>
            
        </div>
)
}